var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSmileyLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,0A16,16,0,1,0,32,16,16.018,16.018,0,0,0,16,0Zm0,29.34A13.34,13.34,0,1,1,29.34,16,13.356,13.356,0,0,1,16,29.34ZM6.635,10.387A2.419,2.419,0,0,1,9.94,9.5a2.419,2.419,0,1,1,4.191,2.419l-2.419,4.191L7.521,13.692A2.419,2.419,0,0,1,6.635,10.387Zm11.171,1.545A2.419,2.419,0,1,1,21.989,9.5a2.419,2.419,0,0,1,2.432,4.184l-4.183,2.432Zm7.924,7.853A10.392,10.392,0,0,1,15.986,26.1a10.393,10.393,0,0,1-9.745-6.314l2.46-1.01a7.845,7.845,0,0,0,7.284,4.664,7.846,7.846,0,0,0,7.284-4.664Z",
    fill: "#0071B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmileyLike);
export default __webpack_public_path__ + "static/media/icon-smiley-like.8a394de89f6f3f1fa086190076b04291.svg";
export { ForwardRef as ReactComponent };